import React from "react";
import { Form } from "react-bootstrap";
import { push, removeParam, setParam } from "pages/search/api/filterUrlMaker";
import { getParam } from "lib/routing";
import { _t } from "app/i18n/i18n";

export function OrderByDropdownRedesign() {
  return (
    <Form.Control
      as="select"
      size="sm"
      className="d-inline w-auto mr-2"
      onChange={(e) => orderBy(e.target.value)}
      defaultValue={getParam("sort") || ""}
    >
      <option value="Date_Desc">{_t("Order by date (newest)")}</option>
      <option value="Date_Asc">{_t("Order by date (oldest)")}</option>
      <option value="Pages_Desc">{_t("Order by pages (most)")}</option>
      <option value="Pages_Asc">{_t("Order by pages (fewest)")}</option>
      <option value="ReadCount_Desc">{_t("Order by popularity")}</option>
    </Form.Control>
  );
}

const orderBy = (value) => {
  if (value) {
    push(setParam("sort", value));
  } else {
    push(removeParam("sort"));
  }
};
